import React from 'react'
import ComparisonDetalingBanner from './ComparisonDetalingBanner'
import ComparisonTrustSlider from './ComparisonTrustSlider'
import ComparisonDetalingContent from './ComparisonDetalingContent'
import ComparisonDetalingEvaluating from './ComparisonDetalingEvaluating'
import ComparisonDetalingLogistics from './ComparisonDetalingLogistics'
import WmsFaq from '../../LogisticsServices/wmsPage/WmsFaq'
import GroceriesContact from '../../Industries/GroceriesQuickCommerce/GroceriesContact'
import { BaseUrl } from '../../../helper/BaseUrl'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchJson } from '../../../helper/fetchJson'



export default function ComparisonDetaling({ initialData }) {
  const { slug } = useParams();
  const [Data, setData] = React.useState(initialData || {});
  const navigate = useNavigate();

  React.useEffect(() => {
    let active = true;

    if (initialData?.slug === slug) {
      setData(initialData);
    } else {
      fetchJson(`${BaseUrl}/api/comparison/view/${slug}`)
        .then((result) => {
          if (!active) return;

          if (!result?.comparison) {
            navigate("/404");
            return;
          }

          setData({
            ...result.comparison,
            author: result.author,
          });
        })
        .catch((error) => console.error("Fetch error:", error.message));
    }

    return () => {
      active = false;
    };
  }, [slug, initialData, navigate]);

  const faqData = [
    {
      id: "0",
      question: "01. What is the difference between Mobility Infotech Logistics and Bringg?",
      answer: "It streamlines planning, routing, and execution across automotive logistics operations, reducing delays and improving coordination between dealers, warehouses, and carriers. By optimizing delivery schedules and routes, it ensures timely deliveries, better fleet utilization, enhanced visibility, and consistent performance across complex supply chain networks.",
    },
    {
      id: "1",
      question: "02. Which platform is better for enterprise logistics management?",
      answer: " It streamlines planning, routing, and execution across automotive logistics operations, reducing delays and improving coordination between dealers, warehouses, and carriers. By optimizing delivery schedules and routes, it ensures timely deliveries, better fleet utilization, enhanced visibility, and consistent performance across complex supply chain networks.",
    },
    {
      id: "2",
      question: "03. Does Mobility Infotech Logistic support real-time shipment tracking?",
      answer: "YIt streamlines planning, routing, and execution across automotive logistics operations, reducing delays and improving coordination between dealers, warehouses, and carriers. By optimizing delivery schedules and routes, it ensures timely deliveries, better fleet utilization, enhanced visibility, and consistent performance across complex supply chain networks.",
    },
    {
      id: "3",
      question: "04. Which platform offers better route optimization capabilities?",
      answer: " It streamlines planning, routing, and execution across automotive logistics operations, reducing delays and improving coordination between dealers, warehouses, and carriers. By optimizing delivery schedules and routes, it ensures timely deliveries, better fleet utilization, enhanced visibility, and consistent performance across complex supply chain networks.",
    },
    {
      id: "4",
      question: "05. Is Mobility Infotech Logistic suitable for last-mile delivery operations?",
      answer: " It streamlines planning, routing, and execution across automotive logistics operations, reducing delays and improving coordination between dealers, warehouses, and carriers. By optimizing delivery schedules and routes, it ensures timely deliveries, better fleet utilization, enhanced visibility, and consistent performance across complex supply chain networks.",
    },
    {
      id: "5",
      question: "06. Which industries benefit from Mobility Infotech Logistics?",
      answer: " It streamlines planning, routing, and execution across automotive logistics operations, reducing delays and improving coordination between dealers, warehouses, and carriers. By optimizing delivery schedules and routes, it ensures timely deliveries, better fleet utilization, enhanced visibility, and consistent performance across complex supply chain networks.",
    }
  ];

  return (
    <>
      <ComparisonDetalingBanner data={Data} />
      <ComparisonTrustSlider />
      <ComparisonDetalingContent data={Data} author={Data.author} />
      <ComparisonDetalingEvaluating />
      <ComparisonDetalingLogistics />
      <WmsFaq faqData={faqData} />
      <div className="comparision-form"> <GroceriesContact /> </div>

    </>
  )
}
